<div ng-controller="taskDetailsControllerNX as taskCtrl" class="modal-view task">
    <div c-select-list ng-if="taskCtrl.showTaskConfigsList"
         toggle="0"
         items="taskCtrl.taskConfigs"
         selected-item="taskCtrl.selectedTaskConfig"
         auto-select-single-item="true"
         validation="taskCtrl.setupValidation">
    </div>
    <c-auto-form config="taskCtrl.autoFormConfig"></c-auto-form>
</div>